<template>
  <div class="apply-partner">
    <header>
      <img src="../../assets/images/card-img/buy-card-img/icon-24-fanhui.png" alt="" @click="$router.replace('/my')"> 
      <p>
        申请合伙人
      </p>
    </header>
    <section>
      <wasdeveloping></wasdeveloping>
    </section>
  </div>
</template>
<script>

import wasdeveloping from '../../components/unrealized/was-developing.vue';

export default {
  data(){
    return{

    }
  },
  components:{
    wasdeveloping
  }
}
</script>
<style lang="less" scoped>
  .apply-partner{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    header{
      width: 100%;
      height: .88rem;
      display: flex;
      align-items: center;
      border-bottom: 0.01rem #BFBFBF solid;
      img{
        width: .18rem;
        height: .35rem;
        margin-left: .33rem;
      }
      p{
        width: 6.54rem;
        font-family: PingFang-SC-Bold;
        color: #333333;
        font-size: 0.36rem;
        font-weight: bold;
        text-align: center;
      }
    }
    section{
      width: 100%;
    }
  }
</style>